module.exports = __webpack_public_path__ + "static/media/viewReturnOrderNavigation.6ca01713.png";